import React from 'react'
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SavingsIcon from '@mui/icons-material/Savings';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import AddBusinessRoundedIcon from '@mui/icons-material/AddBusinessRounded';
import LocalMallRoundedIcon from '@mui/icons-material/LocalMallRounded';
import { formatPrice } from '../helper/functions';
import { SYMBOL } from '../helper/constant';

export default function TopCards({ commonStats }) {
    return (
        <div className='row mt-4 d-flex justify-content-center'>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <MonetizationOnIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>{SYMBOL} Price</h6>
                                <p>${commonStats.tokenPrice ? formatPrice(commonStats.tokenPrice) : 0}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <RecordVoiceOverIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>Total User</h6>
                                <p>{commonStats.totalusers ? parseInt(commonStats.totalusers) : 0}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <AccountBalanceIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>{SYMBOL} Amount</h6>
                                <p>{commonStats.totalstaketoken ? formatPrice(commonStats.totalstaketoken) : 0}</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <SavingsIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>Current APR</h6>
                                <p>{commonStats.interest}%</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <LocalFireDepartmentRoundedIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>Today’s Buyback and Burn</h6>
                                <p>{formatPrice(commonStats.buyback)} BNB</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <AddBusinessRoundedIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>Today’s Add Liquidity</h6>
                                <p>{formatPrice(commonStats.addliquidity)} BNB</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <LocalMallRoundedIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>2% DBB</h6>
                                <p>{formatPrice(commonStats.dbb)} BNB</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
